<template>
  <NuxtLoadingIndicator />
  <NuxtLayout>
    <NuxtPage @passDataToHeader="$emit('passDataToHeader', $event)" />
  </NuxtLayout>
  <AppFooter v-if="showFooter" />
  <UNotifications class="w-full sm:w-1/3 z-30" :timeout="60000" pause-timeout-on-hover>
    <template #title="{ title }">
      <span v-html="title" />
    </template>

    <template #description="{ description }">
      <span v-html="description" />
    </template>
  </UNotifications>
  <AuthPopup
    v-if="showUidLoginPopup"
    :initialMode="'login'"
    :uidLoginMode="true"
    :uidEmail="uidLoginEmail"
    @close="clearUidLoginState"
  />
  <div v-if="uidLoginError" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
    <div class="bg-white rounded-2xl shadow-xl p-8 max-w-md w-full text-center">
      <div class="text-2xl font-bold text-red-600 mb-4">Login Error</div>
      <div class="text-gray-700 mb-6">{{ uidLoginError }}</div>
      <button class="px-4 py-2 bg-blue-600 text-white rounded-lg" @click="clearUidLoginError">Close</button>
    </div>
  </div>
</template>

<style>
h1 {
  @apply text-8xl;
  @apply font-semibold;
}
h2 {
  @apply text-4xl;
  @apply leading-8;
  @apply font-semibold;
  @apply md:text-4xl;
  @apply md:leading-10;
}
strong {
  @apply font-semibold;
}
h3 {
  @apply text-3xl;
  @apply font-semibold;
}
p {
  @apply text-xl;
  @apply leading-8;
}
a {
  @apply text-Tourscanner_blue-source hover:dark:text-gray-400;
}

.ts-link {
  @apply text-Tourscanner_blue-source hover:dark:text-gray-400 underline cursor-pointer;
}
li {
  @apply text-xl;
  @apply leading-8;
}
.ts-button {
  @apply bg-gradient-to-r from-ts_blue_to to-ts_blue_from;
  @apply rounded-full px-4 py-2;
  @apply text-white;
}

body {
  @apply dark:bg-[#121212] dark:text-white;
}

/* ON mobile hide the default contact us button */
@media (max-width: 767px) {
  #arcontactus {
    display: none !important;
  }
}
</style>

<script setup>
import AuthPopup from '~/components/ai/AuthPopup.vue';
import { useAuth } from '~/composables/useAuth';
const route = useRoute();
const { proxy } = useScriptMetaPixel();
const tracking = useTrackingId();
const runtimeConfig = useRuntimeConfig();
const { initialize } = useHotjar();
const { initAuth, showUidLoginPopup, uidLoginEmail, uidLoginError, clearUidLoginState, clearUidLoginError } = useAuth();

const stop = watch(
  () => tracking.trackingId.value,
  (newTrackingId) => {
    if (newTrackingId) {
      // Initialize Hotjar && Facebook Pixel
      if (process.client) {
        initialize();
        proxy.fbq('init', runtimeConfig.public.metapixelID, {
          external_id: newTrackingId,
          extern_id: newTrackingId,
        });
        proxy.fbq('track', 'PageView');
      }
      stop();
    }
  },
);

// ✅ FIXED: Now properly awaiting initAuth
onMounted(async () => {
  if (!route?.name?.includes('product') && !route?.name?.includes('agent') && !route?.name?.includes('ai')) {
    initAnyChat();
  }
  initFillout();

  // ✅ Await initAuth to ensure logincode processing completes
  try {
    await initAuth();
  } catch (error) {
    console.error('Failed to initialize auth:', error);
  }
});

function initAnyChat() {
  (function (d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {
      return;
    }
    js = d.createElement(s);
    js.id = id;
    js.src =
      'https://api.anychat.one/widget/2c3414ed-c5f7-3fb6-a295-3e13dba23419?r=' + encodeURIComponent(window.location);
    fjs.parentNode.insertBefore(js, fjs);
  })(document, 'script', 'contactus-jssdk');
}

function initFillout() {
  const script = document.createElement('script');
  script.src = 'https://server.fillout.com/embed/v1/';
  script.async = true;
  document.body.appendChild(script);
}
</script>
